
import { defineComponent } from 'vue';
import UserInfoDto from "@/dto/UserInfoDto";
import store from "@/store";
import PasswordUtils from "@/utils/PasswordUtils";
import TWebKaiinJoho from "@/entity/TWebKaiinJoho";
import ValidateUtils from "@/utils/ValidateUtils";
import LoadingUtils from "@/utils/LoadingUtils";
import CloneUtils from "@/utils/CloneUtils";
import {CancelTokenSource} from "axios";
import Dialog from "@/utils/Dialog";

export default defineComponent({
  name: 'SettingsView',
  components: {},
  async created() {
    console.log('>>>>created>>>>')
    this.configs = (await this.axios.get('/getConfig', {params: {keys: [
          'keitai_kaisha_docomo',
          'keitai_kaisha_au',
          'keitai_kaisha_softbank',
          'keitai_kaisha_rakuten',
          'mail_domain']}})).data as { [key: string]: string }
    this.axios.get('/getSettingsKaiinJoho', {params:{kaiinId: this.userInfo.userId}}).then(res => {
      this.kaiinJoho = res.data as TWebKaiinJoho
      this.prevKaiinJoho = CloneUtils.clone(this.kaiinJoho)
      //this.loginIdOperation()
    })
    this.axios.get('/getSettingsConfirmCodeSession', {params:{kaiinId: this.userInfo.userId}}).then(res => {
      this.confirmCodeSession = res.data as string
    })
  },
  data(){
    return {
      configs: {} as { [key: string]: string },
      showPassword: false,
      password: '' as string,
      confirmPassword: '',
      kaiinJoho: {} as TWebKaiinJoho,
      prevKaiinJoho: {} as TWebKaiinJoho,
      confirming: false,
      confirmCode: '',
      confirmCodeSession: '',
      done: false,
      loginIdValid: true,
      maiAddressMessage: '',
      cancelTokenSource: null as CancelTokenSource | null
    }
  },
  methods: {
    async confirm(){
      LoadingUtils.start()
      this.kaiinJoho.webKaiinPassword = this.password
      this.axios.post('/setSettingsConfirmCodeSession',this.kaiinJoho).then(res => {
        window.scrollTo({top: 0});
        this.confirming = true
        this.confirmCodeSession = (res.data as string).toString()
      }).catch(e => {
        //console.log(e)
      }).finally(() => {
        LoadingUtils.end()
      })
    },
    async backFromConfirm(){
      this.kaiinJoho.webKaiinPassword = null
      this.axios.post('/resetSettingsConfirmCodeSession', this.kaiinJoho).then(res => {
        this.confirming = false
        this.confirmCode = ''
        this.confirmCodeSession = ''
      })
    },
    async updateSettings() {
      const timeout = (await this.axios.get('/isTimeoutInSession', {params:{configKey: 'kakunin_cd_kigen'}})).data as boolean
      if (!timeout) {
        Dialog.confirm('設定を変更してよろしいですか？').then((ok)=>{
          if(ok){
            LoadingUtils.start()
            this.kaiinJoho.webKaiinPassword = this.password
            this.axios.post('/updateSettings', this.kaiinJoho).then((res) => {
              window.scrollTo({top: 0});
              this.userInfo.userName = this.kaiinJoho.webKaiinName as string
              this.backFromConfirm()
              this.done = true
            }).catch((e) => {
              //
            }).finally(() => {
              LoadingUtils.end()
            })
          }
        })
      }else{
        this.backFromConfirm();
        (this.$refs.alertDialog as any).show('確認コードの有効期限が切れています。再設定してください。')

      }
    },
    loginIdOperation(){
      this.maiAddressMessage = ''
      if(this.kaiinJoho.webKaiinLoginId){
        if(ValidateUtils.isEMailAddress(this.kaiinJoho.webKaiinLoginId)){
          this.axios.post('/existsMXRecordFroEmail', { mailAddress: this.kaiinJoho.webKaiinLoginId } ).then(res => {
            const v = res.data as { [key: string]: string | boolean };
            if(v.mailAddress===this.kaiinJoho.webKaiinLoginId){
              if(!(v.result as boolean)){
                this.maiAddressMessage = 'メールアドレスのドメインが正しくありません。'
                this.loginIdValid = false
              }else{
                this.axios.get('/existsMailAddressNotSelf', {params: {mailAddress:  this.kaiinJoho.webKaiinLoginId}}).then((res) => {
                  this.loginIdValid = !res.data as boolean;
                  if(!this.loginIdValid){
                    this.maiAddressMessage = 'このメールアドレスは既に登録されています。'
                  }
                }).catch()
              }
            }else{
              console.log('追い越し')
            }
          }).catch(e => {
            console.log(e)
            this.loginIdValid = false
          })
        }else{
          this.maiAddressMessage = 'メールアドレスが正しくありません。'
          this.loginIdValid = false
        }
      }else{
        this.loginIdValid = false
      }
    },
  },
  computed: {
    canConfirm(): boolean {
      const result = (this.validPassword && this.password===this.confirmPassword) || ((!this.password && !this.confirmPassword))
          && this.loginIdValid
          && !!this.kaiinJoho.webKaiinName
      console.log('result='+result)
      console.log('!!this.password=' + !!this.password)
      console.log(JSON.stringify(this.kaiinJoho) !== JSON.stringify(this.prevKaiinJoho) || !!this.password)
      return result && (JSON.stringify(this.kaiinJoho) !== JSON.stringify(this.prevKaiinJoho) || !!this.password)
    },
    validPassword():boolean{
      return PasswordUtils.validPassword(this.password)
    },
    validConfirmCode(): boolean{
      return this.confirmCode.length===6 && this.confirmCode===this.confirmCodeSession
    },
    /**
     * ユーザー情報(store)
     */
    userInfo: {
      get(): UserInfoDto {
        return store.getters.userInfo as UserInfoDto
      },
      set(userInfo: UserInfoDto) {
        store.commit('setUserInfo', userInfo)
      }
    },
  }
});
